var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToday(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 2,
    height: 3.4,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 19.6,
    width: 2,
    height: 3.4,
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 11,
    width: 3.4,
    height: 2,
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6,
    y: 11,
    width: 3.4,
    height: 2,
    rx: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 2,
    height: 3.4,
    rx: 1,
    transform: "rotate(45 12 12)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 2,
    height: 3.4,
    rx: 1,
    transform: "rotate(135 12 12)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 2,
    height: 3.4,
    rx: 1,
    transform: "rotate(225 12 12)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 2,
    height: 3.4,
    rx: 1,
    transform: "rotate(315 12 12)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToday);
export default __webpack_public_path__ + "static/media/today.345e051871a93b590b1c3e22a25bd364.svg";
export { ForwardRef as ReactComponent };